require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-study-ellis-whittam-zeus.json") })
        }
      }, "path---study-study-ellis-whittam-zeus");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-study-ellis-whittam-zeus!./.cache/json/study-study-ellis-whittam-zeus.json
// module id = 933
// module chunks = 231608221292675